import { authAxios } from "../Axios/createAxios";
import { LOGOUT } from "./Api";
import Cookie from "cookie-universal";
export default function LogOut() {
  const cookie = Cookie();
  async function handleLogOut() {
    try {
      await authAxios.post(`/${LOGOUT}`, {}).then((res) => console.log(res));
      cookie.remove("bearer");
      window.location.reload();
    } catch (err) {
      console.log(err);
    }
  }
  return (
    <button className="inline-block" onClick={handleLogOut}>
      Log Out
    </button>
  );
}
